import moment from 'moment';
import ValueFilter from './ValueFilter';
import DateRangeFilter from './DateRangeFilter';

interface TimePeriodUnitValue {
  value: number;
  unit: moment.unitOfTime.DurationConstructor;
}

interface TimePeriodCustomValue {
  value: string;
  unit: 'custom';
}

export type TimePeriodFilterValue = TimePeriodUnitValue | TimePeriodCustomValue;

class TimePeriodFilter extends ValueFilter<TimePeriodFilterValue> {
  toBookmarkConfiguration() {
    return this.getValue();
  }

  set(value: TimePeriodFilterValue) {
    super.set(value ?? { unit: 'weeks', value: 6 });
  }

  get startTime() {
    const value = this.getValue();

    if (value.unit === 'custom') {
      return moment(value.value);
    } else {
      return moment(this.endTime)
        .add(-value.value, value.unit)
        .startOf('week')
        .toDate();
    }
  }

  get endTime() {
    return moment().add(1, 'week').startOf('week');
  }

  asDateRangeFilter(): DateRangeFilter {
    return new DateRangeFilter(
      {
        start: this.startTime.toISOString(),
        end: this.endTime.toISOString(),
      },
      false
    );
  }
}

export default TimePeriodFilter;
